/*
 * @Author: liuxw@codoon.com
 * @Date: 2020-10-29 15:56:11
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2021-07-12 10:50:15
 * @Content:
 */

import { map, filter } from "lodash";
import React, { FC, memo, useCallback, useState } from "react";
import { IActivityInfo } from "../../../service/activity/interface";
import day from "../../../utils/day";
import { getGoalState } from "../../utils";
import GoalCarousel from "./GoalCarousel";
import GoalDetail from "./GoalDetail";
import "./index.less";

const PREFIX = "ProgressCard";

interface IProps {
  activityInfo: IActivityInfo;
  onViewDetail: () => void;
  selectedGoalNum: number;
  onSelectGoal: (nextGoalNum: number) => void;
}

const ProgressCard: FC<IProps> = memo(
  ({ activityInfo, onViewDetail, selectedGoalNum, onSelectGoal }) => {
    const renderBody = useCallback(() => {
      const goals = activityInfo.goals;
      const finishGoalCount = activityInfo.finish_goal_count;
      const selectedGoal = goals[selectedGoalNum];
      const currTime = day();
      const selectedGoalState = getGoalState(selectedGoal, currTime);

      // finish_goal_count == -1：报名时选择一个目标，并完成该单个目标模式
      if (activityInfo.finish_goal_count == -1) {
        // 单个目标
        return (
          <div className={`${PREFIX}-bodyGoalDetail`}>
            <div className={`${PREFIX}-nameBox`}>
              <div className={`${PREFIX}-name`}>{selectedGoal.goal_name}</div>
            </div>
            <GoalDetail
              goal={selectedGoal}
              state={selectedGoalState}
              currTime={currTime}
            />
          </div>
        );
      } else {
        // 多个目标
        return (
          <>
            <div className={`${PREFIX}-bodyGoalCount`}>
              {finishGoalCount == goals.length
                ? "完成以下全部目标"
                : `完成以下任意${finishGoalCount}个目标`}
            </div>
            <div className={`${PREFIX}-bodyCarousel`}>
              <GoalCarousel
                goals={map(goals, (goal, index) => {
                  const goalState = getGoalState(goal, currTime);
                  return {
                    state: goalState,
                  };
                })}
                selectedGoalNum={selectedGoalNum}
                onClick={onSelectGoal}
              />
            </div>
            <div className={`${PREFIX}-bodyGoalName`}>
              {selectedGoal.goal_name || ""}
            </div>
            <div className={`${PREFIX}-bodyGoalDetail`}>
              <GoalDetail
                goal={selectedGoal}
                state={selectedGoalState}
                currTime={currTime}
              />
            </div>
          </>
        );
      }
    }, [activityInfo, onSelectGoal, selectedGoalNum]);

    return (
      <div className={PREFIX}>
        <div className={`${PREFIX}-header`}>
          <div className={`${PREFIX}-headerTitle`}>{activityInfo.name}</div>
        </div>
        <div className={`${PREFIX}-body`}>{renderBody()}</div>
        <div className={`${PREFIX}-footer`}>
          <div className={`${PREFIX}-footerBtn`} onClick={onViewDetail}>
            <div className={`${PREFIX}-footerBtnText`}>查看活动详情</div>
            <img
              className={`${PREFIX}-footerBtnIcon`}
              src="https://s1.codooncdn.com/operation-tools/internal-user/2020-10-30T10.13.39/9x14x332xpauHMgIoDs2zmyDxvK.png"
            />
          </div>
        </div>
      </div>
    );
  }
);

export default ProgressCard;
